<template>
  <div class="DarkWhite">
    <!-- <v-card
      class="mb-5"
    >
        <v-card-text>
        <v-row>
          <v-col cols="12" sm="6" md="3">
            <v-autocomplete
            v-model="FundCode"
            item-text="Description"
            item-value="FundCode"
            :items="funds"
            hide-details
            color="header"
            label="Filter by Funds"
          >
          </v-autocomplete>
          </v-col>
          <v-col cols="12" sm="6" md="3">
            <v-autocomplete
            v-model="ClassificationID"
            item-text="Code"
            item-value="ClassificationID"
            :items="classifications"
            hide-details
            color="header"
            label="Filter by Classification"
          >
          </v-autocomplete>
          </v-col>
          <v-col cols="12" sm="6" md="3">
            <v-menu
              dense
              ref="menu1"
              v-model="menu1"
              :close-on-content-click="false"
              :return-value.sync="DateRange"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-combobox
                  dense
                  v-model="DateRange"
                  label="Date Range"
                  color="header"
                  v-bind="attrs"
                  v-on="on"
                  class="mt-5"
                  hide-details
                  clearable
                >
                </v-combobox>
              </template>
              <v-date-picker
                v-model="DateRange"
                no-title
                scrollable
                range
                color="header"
                :max="new Date().toISOString().substr(0, 10)"
              >
                <v-spacer></v-spacer>
                <v-btn text color="header" @click="menu1 = false">
                  Cancel
                </v-btn>
                <v-btn
                  class="white--text"
                  color="header"
                  @click="$refs.menu1.save(DateRange)"
                >
                  OK
                </v-btn>
              </v-date-picker>
            </v-menu>
          </v-col>
          <v-col cols="12" sm="6" md="3">
            <v-autocomplete
            v-model="UserID"
            item-text="name"
            item-value="UserID"
            :items="users"
            hide-details
            color="header"
            label="Filter by User"
          >
          </v-autocomplete>
          </v-col>
          <v-col cols="12">
            <v-text-field
            v-model="searchText"
            append-icon="mdi-magnify"
            placeholder="Search Item here..."
            color="green darken-2"
            class="mr-2 mt-2"
            dense
            hide-details
          ></v-text-field>
          </v-col>
        </v-row>
        </v-card-text>
    </v-card> -->
    <v-data-table
      :headers="headers"
      :items="itemList"
      :options.sync="options"
      :server-items-length="totalCount"
      :loading="loading"
      :footer-props="footerProps"
      class="elevation-1 pt-2"
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-text-field
            style="max-width: 300px"
            v-model="searchText"
            append-icon="mdi-magnify"
            placeholder="Search here..."
            color="green darken-2"
            class="mr-2 mt-2"
            dense
            hide-details
          ></v-text-field>
          <v-spacer></v-spacer>
          <v-autocomplete
            v-model="TypeID"
            item-text="description"
            item-value="id"
            :items="sticker_types"
            hide-details
            color="header"
            label="Filter by Type"
            style="max-width: 200px;"
            class="mr-3"
          >
          </v-autocomplete>
          <vue-json-to-csv 
          :json-data="itemListForCSV"
          :labels="{ 
            DateCreated: { title: 'Date Generated' },
            Description: { title: 'Description' },
            Type: { title: 'Type' },
            IARCODEs: { title: 'IAR CODES' },
            ICSCODEs: { title: 'ICS CODES' },
            PARCODEs: { title: 'PAR CODES' },
            }"
          csv-title="Batched Stickers">
            <v-btn
              outlined
              color="green darken-2"
              class="mr-2"
              dark
              :loading="loadingCSV"
            >
              <v-icon class="mr-1">mdi-microsoft-excel</v-icon>
              CSV
            </v-btn>
          </vue-json-to-csv>
            <v-btn
              color="green darken-2"
              dark
              @click="generateSticker()"
            >
              <v-icon class="mr-1">mdi-sticker-plus</v-icon>
              <!-- <v-chip label small color="#dc5656" class="mr-1 px-2 white--text darken-2" v-if="itemListDisposal.length > 0"><strong>{{itemListDisposal.length}}</strong></v-chip> -->
              Generate Sticker
            </v-btn>
        </v-toolbar>
      </template>
      <template v-slot:[`item.DateDisposed`]="{ item }">
        {{ formatDate(item.DateCreated) }}
      </template>
      <template v-slot:[`item.Type`]="{ item }">
        <span v-if="item.Type == 1">Newly Purchased</span>
        <span v-else-if="item.Type == 2">Property</span>
      </template>
      <template v-slot:[`item.IARCODEs`]="{ item }">
          <div>
            <div v-if="item.IARCODEs">
              <div v-for="(code, i) in item.IARCODEs.split(',')" :key="'iar-' + i">
                {{ code.trim() }}
              </div>
            </div>
          </div>
      </template>
      <template v-slot:[`item.Codes`]="{ item }">
          <div>
            <div v-if="item.ICSCODEs">
              <div v-for="(code, i) in item.ICSCODEs.split(',')" :key="'ics-' + i">
                {{ code.trim() }}
              </div>
            </div>

            <div v-if="item.PARCODEs">
              <div v-for="(code, i) in item.PARCODEs.split(',')" :key="'par-' + i">
                {{ code.trim() }}
              </div>
            </div>
          </div>
      </template>
      <template v-slot:[`item.Actions`]="{ item }">
        <span class="text-no-wrap">
          <!-- <v-btn
            color="blue darken-2"
            class="mr-2"
            dark
            outlined
            elevation="2"
            x-small
            @click="view(item)"
          >
            View
          </v-btn> -->
          <v-btn
            color="green darken-2"
            class="mr-2"
            dark
            outlined
            elevation="2"
            x-small
            @click="print(item)"
          >
            Print
          </v-btn>
        </span>
      </template>
    </v-data-table>
    <RSModal :rsData="viewData" />
    <GenerateStickerModal :display="showGenerate" />
    <fade-away-message-component
      displayType="variation2"
      v-model="fadeAwayMessage.show"
      :message="fadeAwayMessage.message"
      :header="fadeAwayMessage.header"
      :top="fadeAwayMessage.top"
      :type="fadeAwayMessage.type"
    ></fade-away-message-component>
  </div>
</template>

<script>
export default {
  components: {
    RSModal: () => import("./ViewRS.vue"),
    GenerateStickerModal: () => import("./GenerateSticker.vue"),
  },
  props: {
    fiscalYear: null
  },
  data: () => ({
    searchText: "",
    searchTimeout: null,
    footerProps: { "items-per-page-options": [5, 10, 20, 50, 100, 500] },
    totalCount: 0,
    loading: true,
    options: {},
    fadeAwayMessage: {
      show: false,
      type: "success",
      header: "Successfully Saved!",
      message: "",
      top: 10,
    },
    isLoading: false,
    itemList: [],
    headers: [
        {
          text: 'Description',
          align: 'start',
          sortable: false,
          value: 'Description',
          class: "green darken-2 white--text text-caption font-weight-bold"
        },
        {
          text: 'Type',
          align: 'start',
          sortable: false,
          value: 'Type',
          class: "green darken-2 white--text text-caption font-weight-bold"
        },
        {
          text: 'IAR Codes',
          align: 'start',
          sortable: false,
          value: 'IARCODEs',
          class: "green darken-2 white--text text-caption font-weight-bold"
        },
        {
          text: 'ICS/PAR Codes',
          align: 'start',
          sortable: false,
          value: 'Codes',
          class: "green darken-2 white--text text-caption font-weight-bold"
        },
        {
          text: 'Date Generated',
          align: 'start',
          sortable: false,
          value: 'DateCreated',
          class: "green darken-2 white--text text-caption font-weight-bold"
        },
        { text: 'Actions', value: 'Actions', align: 'center', width: '140', sortable: false, class: "green darken-2 white--text text-caption font-weight-bold" },
      ],
      FundCode: 0,
      ClassificationID: 0,
      UserID: 0,
      TypeID: 0,
      Status: 0,
      funds: [],
      classifications: [],
      users: [],
      DateRange: null,
      return_types: [],
      dialogPrint: false,
      menu1: false,
      menu2: false,
      menu3: false,
      DateType: false,
      DateEnd: null,
      itemListForCSV: [],
      loadingCSV: true,
      viewData: [],
      undisposeData: [],
      itemListDisposal: [],
      showGenerate: false,
      showUndisposal: false,
      action_type: null,
      sticker_types: [
      {id: 0, description: 'All'},
      {id: 1, description: 'Newly Purchased Sticker'},
      {id: 2, description: 'Property Sticker'},
    ],
  }),
  watch: {
    searchText: function () {
      clearTimeout(this.searchTimeout);
      this.searchTimeout = setTimeout(() => {
        this.initialize();
      }, 600);
    },
    options: {
      handler() {
        this.initialize();
      },
      deep: true,
    },
    fiscalYear: {
      handler() {
        this.initialize();
      },
      deep: true,
    },
    TypeID: {
      handler() {
        this.initialize();
      },
      deep: true,
    },
  },
  mounted() {
    this.getAllReturnType();
    this.getFundCodes();
    this.getClassificationByType();
    this.getBudgetTypeAndOffice();
    this.eventHub.$on("closeViewSC", () => {
      this.initialize();
    });
    this.eventHub.$on("closeDisposeItems", () => {
      this.showGenerate = false;
      this.initialize();
    });
  },
  beforeDestroy() {
    this.eventHub.$off("closeViewSC");
    this.eventHub.$off("closeDisposeItems");
  },
  methods: {
    view(item) {
      this.viewData = item;
    },
    print(item) {
      // if(item.ICSIDs){
      // let link = this.apiUrl + "/ics/sticker" + (item.Type == 1 ? "/np" : "") + "/report/" + item.IARIDs + "/" + item.ICSIDs;
      // window.open(link);
      // }
      // else if(item.PARIDs){
      //   let link = this.apiUrl + "/par/sticker" + (item.Type == 1 ? "/np" : "") + "/report/" + item.IARIDs + "/" + item.PARIDs;
      // window.open(link);
      // }
      let link = this.apiUrl + "/sticker/report/" + item.StickerID;
      window.open(link);
    },
    printIIRUP(){
      this.action_type = 3;
      this.dialogPrint = true;
    },
    printIIRUSP(){
      this.action_type = 2;
      this.dialogPrint = true;
    },
    printWMR(){
      this.action_type = 1;
      this.dialogPrint = true;
    },
    generateSticker() {
      this.showGenerate = true
    },
    undispose(data) {
      this.undisposeData = data
      this.showUndisposal = true
    },
    initialize() {
      this.loading = true;
      this.loadingCSV = true;
      if(this.fiscalYear != null){
      let data = new FormData();
      if (this.options.page) {
        data.append("page", this.options.page);
        data.append("itemsPerPage", this.options.itemsPerPage);
      } else {
        data.append("page", 1);
        data.append("itemsPerPage", 10);
      }
      data.append("TypeID", this.TypeID);
      data.append("searchText", this.searchText);
      data.append("FiscalYear", this.fiscalYear);
      data.append("DateRange", this.DateRange && this.DateRange.length > 1 ? this.DateRange : '');
      this.axiosCall("/sticker/getStickers", "POST", data).then((res) => {
        this.loading = false;
        this.loadingCSV = false;
        this.itemList = res.data.data.result;
        this.itemListForCSV = res.data.data.result
        this.totalCount = res.data.data.total;
        if (this.totalCount <= 10) {
          this.options.page = 1;
        }
      });
      }
    },
    confirmUndispose(){
        let data = new FormData();
        let type = this.undisposeData.ICSID ? 1 : this.undisposeData.PARID ? 2 : 0;
        data.append("ItemDID", this.undisposeData.ICSID ? this.undisposeData.ICSItemDID : this.undisposeData.PARID ? this.undisposeData.ICSItemDID : '');
        data.append("type", type);
        this.axiosCall("/undisposeItem", "POST", data).then((res) => {
          console.log(res);
          this.fadeAwayMessage.show = true;
          this.fadeAwayMessage.type = "success";
          this.fadeAwayMessage.message = "Item Successfully undisposed.";
          this.fadeAwayMessage.header = "System Message";
          this.undisposeData = [];
          this.showUndisposal = false;
          this.initialize();
        });
    },
    confirmPrint(){
      if (this.$refs.Formref.validate()) {
      let dates = this.DateRange || [0,0];
      let DateStart = dates[0];
      let DateEnd = dates[1];
      if(this.DateType == false){
        DateStart = 0;
        DateEnd = this.DateEnd;
      }
      let type = '';
      if(this.action_type == 1){
        type = 'wmr'
      }
      else if(this.action_type == 2){
        type = 'iirusp'
      }
      else if(this.action_type == 3){
        type = 'iirup'
      }
      let link = this.apiUrl + "/" + type + "/report/" + DateStart + "/" + DateEnd + "/" + this.ClassificationID + "/" + this.FundCode;
      window.open(link);
      }
    },
    getAllReturnType() {
      this.axiosCall(
              '/getAllReturnType',
              'GET'
          )
          .then((res) => {
              this.return_types = this.prepend({id: 0, description: 'All'},res.data.data);
          })
		},
    getFundCodes() {
      this.axiosCall(
              '/get/getUniqueFundCodes',
              'GET'
          )
          .then((res) => {
              this.funds = this.prepend({FundCode: 0, Description: 'All'},res.data.data);
          })
		},
    getClassificationByType() {
      this.axiosCall(
              '/get/getClassificationByType/1/1',
              'GET'
          )
          .then((res) => {
              this.classifications = this.prepend({ClassificationID: 0, Code: 'All'},res.data.data);
          })
		},
    getBudgetTypeAndOffice() {
      this.axiosCall(
              '/getOfficeAndOthersForCreateUpdate',
              'GET'
          )
          .then((res) => {
              this.users = this.prepend({UserID: 0, name: 'All'},res.data.data.users);
          })
		},
    prepend(value, array) {
    var newArray = array.slice();
    newArray.unshift(value);
    return newArray;
    },
  },
};
</script>